// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    position: 'relative',
    width: '100%',
    marginTop: 142,
    marginBottom: 160,
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down(900)]: {
      justifyContent: 'center',
      marginTop: 60,
      marginBottom: 220,
    },
    [theme.breakpoints.down(500)]: {
      marginBottom: 320,
    },
    [theme.breakpoints.down(326)]: {
      marginBottom: 420,
    },
  },
  image: {
    maxHeight: 900,
    height: '100%',
    [theme.breakpoints.down(1800)]: {
      maxHeight: 800,
    },
    [theme.breakpoints.down(1600)]: {
      maxHeight: 700,
    },
    [theme.breakpoints.down(1368)]: {
      maxHeight: 600,
    },
    [theme.breakpoints.down(1025)]: {
      maxHeight: 500,
    },

  },
  carbonContainer: {
    maxWidth: 1120,
    width: '100%',
    position: 'absolute',
    top: -85,
    left: 27,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    [theme.breakpoints.down(1800)]: {
      maxWidth: 1020,
    },
    [theme.breakpoints.down(1600)]: {
      maxWidth: 920,
    },
    [theme.breakpoints.down(1368)]: {
      maxWidth: 820,
    },
    [theme.breakpoints.down(1025)]: {
      maxWidth: 720,
    },
    [theme.breakpoints.down(900)]: {
      position: 'relative',
      top: 0,
      left: 0,
    },
    [theme.breakpoints.down(768)]: {
      maxWidth: 610,
    },
    [theme.breakpoints.down(525)]: {
      maxWidth: 410,
    },
    [theme.breakpoints.down(400)]: {
      maxWidth: 310,
    },
  },
  carbonInnerContainer: {
    padding: '26px 87px',
    [theme.breakpoints.down(1025)]: {
      padding: '22px 50px',
    },
    [theme.breakpoints.down(768)]: {
      padding: '16px 30px',
    },
  },
  carbonImage: {
    maxHeight: 145,
    height: '100%',
    width: '100%',
  },
  titleText: {
    fontSize: GlobalStyles.fonts.FONT_SIZE_EXTRA_MAX,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_BOLD,
    color: GlobalStyles.color.COLOR_BLACK_GREEN,
    [theme.breakpoints.down(1800)]: {
      fontSize: 42,
    },
    [theme.breakpoints.down(1600)]: {
      fontSize: 32,
    },
    [theme.breakpoints.down(1368)]: {
      fontSize: 28,
    },
    [theme.breakpoints.down(1024)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_MAX
    },
  },
  descriptionText: {
    whiteSpace: 'pre-line',
    fontSize: 33,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_MEDIUM,
    [theme.breakpoints.down(1800)]: {
      fontSize: 28,
    },
    [theme.breakpoints.down(1600)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_MAX
    },
    [theme.breakpoints.down(1368)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE
    },
    [theme.breakpoints.down(1025)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE
    },
  }
});

export default styles;
